import * as api from "../api/userAPI";
import * as types from "../constants/userConstants";

// Profile View Request Actions
export const createProfileViewRequestAction = (profileOwnerId) => async (dispatch) => {
  try {
    const { error, data } = await api.createProfileViewRequest(profileOwnerId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.CREATE_PROFILE_VIEW_REQUEST_SUCCESS,
      payload: data,
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.CREATE_PROFILE_VIEW_REQUEST_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

export const getReceivedProfileViewRequestsAction = (status, limit = 25, skip = 0) => async (dispatch) => {
  try {
    const { error, data } = await api.getReceivedProfileViewRequests(status, limit, skip);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_RECEIVED_PROFILE_VIEW_REQUESTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.GET_RECEIVED_PROFILE_VIEW_REQUESTS_FAIL,
      payload: error.message,
    });
  }
};

export const getSentProfileViewRequestsAction = (status, limit = 25, skip = 0) => async (dispatch, getState) => {
  // Check if user is authenticated before making API call
  try {
    const profile = localStorage.getItem("profile");
    if (!profile) {
      // User is not authenticated, don't make API call
      return;
    }
    const parsedProfile = JSON.parse(profile);
    if (!parsedProfile?.accessToken) {
      // No access token, user is not authenticated
      return;
    }
  } catch (error) {
    // Error parsing profile, user is not authenticated
    return;
  }

  try {
    const { error, data } = await api.getSentProfileViewRequests(status, limit, skip);
    if (error) {
      // If there's an error, it might be a 401 (unauthorized) - user might have logged out
      // Since handleApiError doesn't preserve status code, we'll just return silently
      // The authentication check above should prevent most cases, but this is a safety net
      return;
    }
    dispatch({
      type: types.GET_SENT_PROFILE_VIEW_REQUESTS_SUCCESS,
      payload: data,
      skip, // Pass skip to reducer for pagination logic
    });
  } catch (error) {
    // Only dispatch error if it's not a 401 (unauthorized) - user might have logged out
    if (error?.response?.status !== 401 && error?.status !== 401) {
      dispatch({
        type: types.GET_SENT_PROFILE_VIEW_REQUESTS_FAIL,
        payload: error.message,
      });
    }
  }
};

export const acceptProfileViewRequestAction = (requestId, accessType = "unlimited", expiryValue = null, expiryUnit = null) => async (dispatch) => {
  try {
    const { error, data } = await api.acceptProfileViewRequest(requestId, accessType, expiryValue, expiryUnit);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.ACCEPT_PROFILE_VIEW_REQUEST_SUCCESS,
      payload: data,
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.ACCEPT_PROFILE_VIEW_REQUEST_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

export const denyProfileViewRequestAction = (requestId) => async (dispatch) => {
  try {
    const { error, data } = await api.denyProfileViewRequest(requestId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.DENY_PROFILE_VIEW_REQUEST_SUCCESS,
      payload: data,
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.DENY_PROFILE_VIEW_REQUEST_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

export const revokeProfileViewRequestAction = (requestId) => async (dispatch) => {
  try {
    const { error, data } = await api.revokeProfileViewRequest(requestId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.REVOKE_PROFILE_VIEW_REQUEST_SUCCESS,
      payload: data,
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.REVOKE_PROFILE_VIEW_REQUEST_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

export const clearReceivedProfileViewRequestsAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_RECEIVED_PROFILE_VIEW_REQUESTS,
  });
};

export const clearSentProfileViewRequestsAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_SENT_PROFILE_VIEW_REQUESTS,
  });
};

export const withdrawProfileViewRequestAction = (requestId) => async (dispatch) => {
  try {
    const { error, data } = await api.withdrawProfileViewRequest(requestId);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.WITHDRAW_PROFILE_VIEW_REQUEST_SUCCESS,
      payload: { requestId },
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.WITHDRAW_PROFILE_VIEW_REQUEST_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

